import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { PublicShell, PublicMessage, PublicError } from "@/components/PublicShell";

export default function OptOutPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/optout/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(apiError(e.response?.data?.detail))); }, [token]);
  const confirm = async () => {
    setBusy(true);
    try { await api.post(`/public/optout/${token}`); setInfo({ ...info, done: true }); } catch (e) { setError(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <PublicShell>
      <div data-testid="optout-page">
        {error && <PublicError text={error} testid="optout-invalid" />}
        {!error && !info && <div className="py-10 text-center text-slate-400"><Loader2 className="animate-spin mx-auto" /></div>}
        {info?.done && <PublicMessage title="Sie wurden abgemeldet" text="Sie erhalten von uns keine weiteren Anzeigenanfragen mehr." testid="optout-done" />}
        {info && !info.done && (
          <div className="text-center py-4">
            <h1 className="font-display text-2xl font-bold text-slate-900">Keine weiteren Anfragen?</h1>
            <p className="text-slate-500 mt-2 text-sm">Bestätigen Sie hier, dass <b>{info.customer}</b> keine weiteren Anzeigenanfragen von uns erhalten möchte.</p>
            <Button onClick={confirm} disabled={busy} className="mt-6 bg-[#0B132B] hover:bg-[#1C2541] text-white" data-testid="optout-confirm">Abmeldung bestätigen</Button>
          </div>
        )}
      </div>
    </PublicShell>
  );
}
